export function canAccountBadgeBeEdited(accountBadge) {
    return accountBadge.columns.status === 'valid' && accountBadge.columns.distributionStatus === 'not-printed';
}
